<template>
  <div class="accordion">
    <div class="accordion__visible" @click="clicked">
      <div v-if="image && image.url" class="accordion__image">
        <img :src="image.url" :alt="image.alt">
      </div>
      <div class="accordion__title large p">
        <p
          v-html="title"
        />
        <p
          v-if="subtitle"
          v-html="subtitle"
        />
      </div>
      <Button
        :class="['accordion__trigger button--icon-only', { 'accordion__trigger--open': open }]"
        button-background="transparent"
        button-color="dark"
        :icon-left="icon ? icon : action_type ? 'chevron-right' : 'add'"
      >
      </Button>
    </div>
    <div v-if="!link" :class="['accordion__hidden', { 'accordion__hidden--show': open }]">
      <div v-html="subtext"></div>
    </div>
  </div>
</template>

<script>
import * as components from '@/icons'
import Button from '@/components/partials/Button.vue'
import actionHandler from '@/mixins/actionHandler.mixin'


export default {
  mixins: [actionHandler],
  components: {
    ...components,
    Button
  },
  props: {
    image: {
      type: Object,
      default: () => {}
    },
    title: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    },
    subtext: {
      type: String,
      default: ''
    },
    link: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    external_link: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      open: false
    }
  },
  methods: {
    clicked () {
      if (this.action_type) {
        this.handleAction()
      } else {
        this.open = !this.open
      }

    }
  }
}
</script>

<style lang="scss">
.accordion {
  padding-left: $padding;
  &__visible {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: $accordion-item-padding;
    border-bottom: $accordion-border-color solid $accordion-border-width;
    p {
      display: flex;
      padding-right: 1rem;
      justify-content: space-between;
    }
    svg {
      width: $accordion-trigger-size;
      height: $accordion-trigger-size;
      fill: $accordion-trigger-color;
    }
  }
  &__image {
    width: 3.5rem;
    height: 3.5rem;
    margin-right: $padding;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  &__title {
    flex-grow: 1;
    p + p {
      margin-top: 0;
      opacity: 0.5;
    }
  }
  &__trigger {
    position: static;
    transition: transform 0.4s;
    padding: 0;
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
    }
    &:focus {
      outline: none;
    }
    &--open {
      transform: rotate(45deg);
    }
  }
  &__hidden {
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.4s ease-out, padding 0.1s 0.3s ease-out;
    &--show {
      display: block;
      max-height: 100vh;
      padding: $padding $padding $padding 0;
      transition: max-height 0.4s ease-out, padding 0.1s ease-out;
    }
  }
}
</style>

<docs>
  ```vue
    <Accordion title="title" subtext="subtext" />
    <Accordion title="title" link="/#" />
  ```
  ```scss
    // Variable defaults:
    $accordion-item-padding: rem(16 15 16 0);
    $accordion-trigger-size: rem(16);
    $accordion-trigger-color: color(dark);
    $accordion-border-color: $accordion-trigger-color;
    $accordion-border-width: 1px;
  ```
</docs>
